import React from 'react'
import Link from 'gatsby-link'

const chineseMedicine = () => (
  <div>
    <h2>Chinese Medicine</h2>
    <span>
      <p>
        Chinese Medicine is a complete medical system and has been used
        successfully for over 2,000 years to treat a wide variety of conditions.
        Chinese medicine understands the body to be much like the natural world.
        In the natural world, one ecosystem is interdependent on another. Just
        as rivers create fertile valleys and strong forests hold landslides at
        bay, our body is made of interconnected systems supporting the whole.
        And just like the natural world’s astounding ability to regenerate after
        damage or disaster, so too can the body gain rebalance from illness.
        Chinese medicine is not about forcing unnatural conditions. It is about
        reminding the body of its own natural healing capacity, and providing
        the tools that it needs to best enact this.
      </p>
      <p>
        What began over 2,000 years ago in China is now a vast,
        multi-disciplinary system of medicine that includes techniques honed and
        developed in dozens of countries, including, China, Japan, Korea,
        France, and the United States. At the heart of this medicine is a
        central belief in the body’s ability to heal itself. Using five main
        branches, Acupuncture, Herbal Medicine, Nutrition, Tui Na and Qi Gong,
        Chinese medicine is a complete medical system that is safe, gentle,
        effective and time-tested.
      </p>
      <h4>The five primary branches of Chinese Medicine are:</h4>
      <br />
      <div
        style={{
          paddingLeft: '30px',
        }}
      >
        <p>
          <strong>Acupuncture:</strong> According to Chinese medicine, qi
          (“chee”) or energy, flows through the body on specific pathways. When
          the energy in these pathways is blocked, blood and fluids may become
          blocked as well. There can be pain, discomfort, tissue and organ
          dysfunction. Acupuncture is the insertion of super-fine, sterile
          needles into specific points along these energy channels. Needles
          allow the body to unblock congestion and allow for smooth flow and
          rebalancing of qi and fluids through the body. An acupuncturist may
          use tools other than or in addition to needles to help balance the
          body’s qi and fluids, including acupressure, cupping (the creation of
          suction using glass or plastic cups to release adhesions and
          re-nourish tissues), moxibustion (the burning of moxa, or Chinese
          mugwort, near acupuncture points to increase circulation) and gua sha
          (the application of friction and pressure designed to increase blood
          flow and move stagnation in congested tissues).
        </p>
        <p>
          <strong>Herbal Medicine:</strong> Chinese medicine uses over 350
          plants, minerals and other organic materials to address the underlying
          causes of disease. Herbs with different properties are combined into
          formulas specifically tailored to the unique condition and
          constitution of each patient. Herbs can be taken as teas made from
          raw, powdered or granular herbs, or as teapills. Herbal medicine plays
          a significant role in the treatment of certain conditions.
        </p>
        <p>
          <strong>Nutrition:</strong> Food is medicine, and different foods
          affect the body in different ways . In some cases, it may be necessary
          to modify one’s diet to achieve a long-term health goal, including the
          removal or addition of certain foods within the diet. Some conditions
          can be addressed by food alone, without the use of additional
          medicine.
        </p>
        <p>
          <strong>Tui Na:</strong> Tui Na is a form of therapeutic massage based
          on the chinese concept of energy pathways or “meridians.” Using
          knowledge of energy meridians, tui na helps restore proper flow of
          energy and fluid to the muscles, tendons, ligaments, and joints.
        </p>
        <p>
          <strong>Qi Gong:</strong> As in any system of medicine, exercise is an
          important aspect of generating and maintaining health. Qi Gong, which
          literally means to “cultivate energy,” is an ancient set of movements,
          breathing techniques and focused intention designed to promote natural
          energy, or qi, flow, develop strength, focus and flexibility. Chinese
          Medical practitioners may prescribe qi gong exercises as part of a
          treatment strategy to address specific health complaints.
        </p>
      </div>

      <i>
        The National Institute of Health (NIH) and World Health Organization
        (WHO) recognize acupuncture as effective for treating the following
        conditions:
      </i>
    </span>
    <br />
    <br />
    <ul>
      <li>
        <strong>Ear, Eye, Nose, Throat Disorders:</strong> Sinusitis • Sore
        throat• Hay fever • Earache • Nerve deafness• Ringing in the ears •
        Dizziness • Poor eyesight
      </li>
      <li>
        <strong>Circulatory Disorders:</strong> High blood pressure • Angina
        pectoris • Arteriosclerosis • Anemia
      </li>
      <li>
        <strong>Gastrointestinal Disorders:</strong> Irritable bowel syndrome •
        Spastic colon • Colitis • Constipation • Diarrhea • Food Allergies •
        Ulcers • Gastritis • Abdominal bloating • Hemorrhoids
      </li>
      <li>
        <strong>Gynecological and Genitourinary Disorders:</strong> Premenstrual
        syndrome (PMS) • Irregular, heavy, or painful menstruation •
        Endometriosis • Menopause • Fibroids • Chronic bladder infection •
        Complications in pregnancy • Morning sickness • Kidney stones •
        Impotence • Infertility in men and women • Sexual dysfunction
      </li>
      <li>
        <strong>Immune Disorders:</strong> Candida • Chronic fatigue • HIV and
        AIDS • Epstein Barr virus • Allergies • Lupus • MS • Hepatitis
      </li>
      <li>
        <strong>Addiction:</strong> Smoking Cessation • Drugs • Alcohol
      </li>
      <li>
        <strong>Emotional and Psychological Disorders:</strong> Anxiety •
        Insomnia • Depression • Stress
      </li>
      <li>
        <strong>Musculoskeletal and Neurological Disorders:</strong> Arthritis •
        Neuralgia • Sciatica • Back pain • Bursitis • Tendonitis • Stiff neck •
        Bell’s palsy • Trigeminal Neuralgia • Headaches and Migraines • Stroke •
        Cerebral palsy • Polio • Sprains • Muscle spasms • Shingles
      </li>
      <li>
        <strong>Respiratory Disorders:</strong> Asthma • Emphysema • Bronchitis
        • Colds and flu
      </li>
      <li>
        <strong>Miscellaneous:</strong> Chemotherapy and radiation side effects
        • Diabetes • Dermatological disorders • Weight control
      </li>
    </ul>
    <br />
  </div>
)

export default chineseMedicine



// WEBPACK FOOTER //
// ./src/pages/chinese-medicine.js